import $ from "jquery";
import { track } from "lib/analytics";

const showOverlay = () => {
  const overlay = $("#small-sidebar-overlay");
  const wrapper = $("#page-wrapper");

  overlay[0].className = "visible";
  wrapper[0].className = "overlay-visible";
};

const showSidebar = (event) => {
  const sidebar = $("#small-sidebar");

  event.preventDefault();
  sidebar[0].className = "visible";
  showOverlay();

  track("Mobile navigation", "Open");
};

const hideSidebar = () => {
  const sidebar = $("#small-sidebar");

  if (sidebar.hasClass("visible")) { // remove this conditional if we can
    sidebar[0].className = "hidden";
  }
};

const hideOverlay = () => {
  const wrapper = $("#page-wrapper");
  const overlay = $("#small-sidebar-overlay");

  if (overlay.hasClass("visible")) { // remove this conditional if we can
    overlay[0].className = "hidden";
    wrapper[0].className = "";
  }
};

const hideAll = (event) => {
  event.preventDefault();
  hideSidebar();
  hideOverlay();
  track("Mobile navigation", "Close");
};

export default () => {
  $("#small-sidebar-open-button").on("click", showSidebar);
  $("#small-sidebar-close-button").on("click", hideAll);
  $("#small-sidebar-overlay").on("click", hideAll);
  $("#small-region-select-dropdown").on("change", (event) => {
    track("Mobile navigation - Edition", "Click", event.target.value);
    window.location = event.target.value;
  });
};
